"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requiresTransportAgreement = void 0;
const requiresTransportAgreement = (product) => !!(product.hasAccomodationVehiclePickup ||
    product.hasDefaultVehiclePickup ||
    product.requiresTransportAgreement);
exports.requiresTransportAgreement = requiresTransportAgreement;
//# sourceMappingURL=transport.js.map